import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { BUNDLE_YEARLY_DISCOUNT } from 'modules/billing/lib/constants'

const PeriodSelector = ({
  onChange,
  currentPeriod,
}: {
  onChange: (newPeriod: 'monthly' | 'yearly') => void
  currentPeriod: 'monthly' | 'yearly'
}) => {
  const config = {
    name: 'period',
    options: [
      {
        label: i18n.t('pricing_plans.config_plan.monthly'),
        value: 'monthly',
      },
      {
        label: i18n.t('pricing_plans.config_plan.yearly'),
        value: 'yearly',
      },
    ],
  } as const

  return (
    <Box flexDirection="row" gap="s8">
      <Box flexDirection="row" gap="s24">
        {config.options.map((option) => (
          <Box
            key={option.value}
            onClick={() => onChange(option.value)}
            flexDirection={'row'}
            alignItems={'center'}
            cursor={'pointer'}
            gap="s8"
          >
            <RadioButton
              onChange={() => onChange(option.value)}
              checked={currentPeriod === option.value}
              value={option.label}
            />
            <Text.Normal size="200">{option.label}</Text.Normal>
          </Box>
        ))}
      </Box>
      <Box
        alignSelf="center"
        paddingRight="s8"
        paddingLeft="s8"
        paddingTop="s2"
        paddingBottom="s2"
        background="viridian200"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Text.Normal size="200" color="grey1000">
          {i18n.t('pricing_plans.config_plan.save_yearly', {
            discount: BUNDLE_YEARLY_DISCOUNT,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default PeriodSelector
